/**
 * Copyright 2021 Olympe S.A.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Brick, registerBrick, WorkflowObjectState } from 'olympe';
import {getLogger} from "@olympeio/core";
import {combineLatest} from "rxjs";
import { queryHistoryAtState } from './_workflow';

export default class WorklowHasStateBeenReached extends Brick {

    /**
     * @override
     */
    setupExecution($) {
        // Accept to propagate null
        return combineLatest(this.getInputs().map(i => $.observe(i)));
    }

    /**
     * @protected
     * @param {!BrickContext} $
     * @param {CloudObject} object
     * @param {WorkflowObjectState} state
     * @param {function(boolean)} setReached
     */
    update($, [object, state], [setReached]) {
        // If the object or the workflow becomes null, propagate the info
        if (object === null || state === null ) {
            getLogger('Has state been reached').error('No object or state specified');
            setReached(false);
        } else {
            // Retrieve all WorkflowObjectState and filter them to check if at least one corresponds to the state to verify.
            queryHistoryAtState(object, state)
                .observe($)
                .subscribe((result) => {
                    setReached(result.size() > 0);
                });
        }
    }
}

registerBrick('018171f57c3e4ef67848', WorklowHasStateBeenReached);
